// Back story: Currently we are not able to have enums defined in definition files (d.ts) and have them exported so they
// can be used in source files as values. To go around this we agreed to have these enumerated values defined in a union
// type (`type SomeEnumeratedStates = 'FOO' | 'BAR'`).
//
// Now when it comes to source files we could just referencing the literal type values like 'FOO' or 'BAR' but for
// maintainability we prefer if these values would be accessed over some constant reference. This is where could use
// exported enums (that are eventually compiled into JS objects). A downside with doing such thing, is that we cannot
// offer any type safety on the enum values. Meaning that we cannot apply an interface on an enum that would only hold
// certain values that are defined in the union type that it represents, so technically we could have an enum with
// values that should not belong in there.
//
// ```
// // An enum that is going to reflect the values for `SomeEnumeratedStates`
// enum SOME_ENUM {
//   FOO = 'FOO',
//   BAR = 'BAR',
//   BAZ = 'BAZ' // This would be allowed as there is no type checking on enum values.
// }
// ```
//
// For a little bit of type safety we could use `Record<Keys, Type>` to have the constant object to match the types they
// represent. The only tiny issue I see with this is that if we have values that cannot be used in the dot notation
// (like for example 'foo bar') we would need to reference the object keys like this: `OUR_CONSTANT['foo bar']`
//
// ```
// const HEATMAP_DATA_TYPES: Record<HeatmapDataType, HeatmapDataType> = {
//   click: 'click',
//   movement: 'movement',
//   scroll: 'scroll',
//   engagement = 'engagement',
// };
// ```

export enum HEATMAP_DATA_TYPES {
  CLICK = 'click',
  MOVEMENT = 'movement',
  SCROLL = 'scroll',
  ENGAGEMENT = 'engagement',
}
